export default __webpack_public_path__ + "static/media/popup.b9e9b82a.mp4";